// extracted by mini-css-extract-plugin
export var backButton = "_1f-1";
export var content = "_1f-d";
export var continueButton = "_1f-7";
export var continueHint = "_1f-8";
export var continueRow = "_1f-6";
export var leftInner = "_1f-0";
export var shell = "_1f-e";
export var sidebarContent = "_1f-5";
export var skipButton = "_1f-c";
export var spacer = "_1f-2";
export var spin = "_1f-a";
export var spinner = "_1f-9";
export var spinnerOverlay = "_1f-b";
export var subtitle = "_1f-4";
export var title = "_1f-3";